<template>
  <div class='tour'>
    <!-- <img src='@/assets/nmLogoTekst2.png'> --><br />
    <h1 class='daytour'>North of Montenegro</h1>
    <!-- <div class='tourPic'>
      <img src='@/assets/placestogo/05/01.jpg'>
    </div> -->
    <div
      style='
        margin: 0 auto;
        margin-top: 30px;
        margin-bottom: 30px;
        padding: 10px 5vw;
      '
    >
      <vue-picture-swipe :items='items'></vue-picture-swipe>
    </div>

    <div>
      <ul class='fa-ul'>
        <li>
          <!-- <span class='fa-li'><i class='fas fa-tree fa-2x'></i></span>  -->
          <!-- <span class='fa-li'><img  src='@/assets/logo/lovcen-green.png'/></span>
      <a data-toggle='collapse' href='#tourDescription'><h4 class='titles'>Tour description</h4></a> -->
          <div class='' id=''>
            <p class='pasus'>
              Montenegro can generally be divided to three regions: northern,
              central and southern.
            </p>
            <p class='pasus'>
              The northern region is the richest in natural resources and
              represents a real highland area where natural environment is truly
              considered a challenge for survival. It is characterized by high
              mountains, deep canyons and extremely cold winters with plenty of
              snow yet nice and fresh summers, incredible landscape, abundance
              of forests and generally diverse flora and fauna. Human had
              adapted to such fierce landscape and we may say that in the north
              of Montenegro people live the lives of highlanders. These are by
              rule almost untouched sites where you will always be warmly
              welcomed as old local tradition implies.
            </p>
            <p class='pasus'>
              There are 3 national parks in the north each being specific in its
              own way, with primeval forests, glacial lakes, clear rivers which
              had carved deep canyons, pastures where local people dwell with
              their cattle during summer making far-known dairy delicacies.
            </p>
            <p class='pasus'>
              Horse riding is still very present; people organize and do
              volunteer work in order to successfully complete hard work whereas
              food is homemade and often organic, fitting the conditions in the
              mountains – strong and abundant.
            </p>
            <p class='pasus'>
              Durmitor is the most famous of all national parks in Montenegro,
              listed as one of the most beautiful in the world and recognized by
              UNESCO as natural gem and being on their sites’ list since 1980.
              Tara canyon as the second deepest in the world belongs to the
              park, too.
            </p>
            <p class='pasus'>
              BIogradska Gora national park is known for its primeval untouched
              forest, one of the three of such kind which have remained in
              Europe, where some trees are over 400 years old but also for its
              pearl – Boigradsko Lake – one of 6 glacial lakes in the park.
            </p>
            <p class='pasus'>
              Prokletije national park is the youngest protected area and it’s
              marked by high jagged peaks, the highest in Montenegro, nice
              alpine valleys, diverse flora and fauna and hydro phenomena.
            </p>
            <p class='pasus'>
              The north of Montenegro is a heaven for climbing, hiking,
              canyoning and horse riding lovers and basically all those who
              fancy mountains, untouched nature, domestic food and authentic
              stay away from crowds.
            </p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// import VuePictureSwipe from 'vue-picture-swipe';
export default {
  data () {
    return {
      items: [
        {
          src: require('@/assets/placestogo/05/01.jpg'),
          thumbnail: require('@/assets/placestogo/05/01.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/05/02.jpg'),
          thumbnail: require('@/assets/placestogo/05/02.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/05/03.jpg'),
          thumbnail: require('@/assets/placestogo/05/03.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/05/04.jpg'),
          thumbnail: require('@/assets/placestogo/05/04.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/05/05.jpg'),
          thumbnail: require('@/assets/placestogo/05/05.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/05/06.jpg'),
          thumbnail: require('@/assets/placestogo/05/06.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/05/07.jpg'),
          thumbnail: require('@/assets/placestogo/05/07.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/05/08.jpg'),
          thumbnail: require('@/assets/placestogo/05/08.jpg'),
          w: 0,
          h: 720
        },
        {
          src: require('@/assets/placestogo/05/09.jpg'),
          thumbnail: require('@/assets/placestogo/05/09.jpg'),
          w: 0,
          h: 720
        }
      ]
    }
  }
}
</script>

<style scoped>
h1 {
  background-color: rgba(113, 186, 107, 0.9);
  border-radius: 3px;
  padding: 5px;
}
ul.square {
  list-style-type: square;
  text-align: left;
}
ul.none {
  list-style-type: none;
  text-align: left;
}

.tourPic {
  margin-top: 5vh;
  width: 100%;
}
.tourPic img {
  width: 100%;
}
.tour {
  padding-left: 10vw;
  padding-right: 10vw;
  padding-top: 15vh;
}
.pasus {
  text-align: justify;
  color: rgb(43, 42, 42);
}
.row {
  display: flex;
  flex-wrap: wrap;
  padding: 0 4px;
}

.cont {
  position: relative;
  text-align: center;
  color: white;
}
.link {
  text-decoration: none;
}
.daytrips {
  padding-top: 10vw;
}
</style>



// WEBPACK FOOTER //
// src/components/PTG5_NorthMontenegro.vue